module.exports = __webpack_public_path__ + "img/jump.2f7baed6.jpg";